import { motion } from "framer-motion";

export default function AuthLayout({ children, illustration = "/images/login.webp" }) {
  return (
    <div className="relative min-h-screen w-full bg-[#F0F5FA] overflow-hidden flex items-center justify-center font-sans">
      
      {/* TOP LEFT SHAPE - Precise 'Wave' that pinches toward the center */}
     <div className="absolute top-0 left-0 w-[50%] h-[45%] min-w-[600px] z-0">
      <svg
        viewBox="0 0 800 600"
        className="w-full h-full"
        preserveAspectRatio="none"
      >
        <defs>
          {/* WarrantyMitra Brand Gradient */}
          <linearGradient id="topGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0F4C81" />   {/* deep navy from logo */}
            <stop offset="20%" stopColor="#118AB2" />  {/* cyan blue */}
            <stop offset="55%" stopColor="#1FC8A5" />  {/* teal */}
            <stop offset="100%" stopColor="#52D66A" /> {/* green from logo */}
          </linearGradient>
        </defs>

        <path
          fill="url(#topGrad)"
          d="
            M0,0
            L800,0
            C700,100 500,150 800,500
            C250,50 150,300 0,450
            Z
          "
        />
      </svg>
    </div>

      {/* BOTTOM RIGHT SHAPE - Large deep-blue curve */}
      <div className="absolute bottom-0 right-0 w-[40%] h-[50%] min-w-[500px] z-0">
  <svg
    viewBox="0 0 700 700"
    className="w-full h-full"
    preserveAspectRatio="none"
  >
    <defs>
      {/* WarrantyMitra Brand Gradient */}
      <linearGradient id="bottomGrad" x1="100%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="#0C3C66" />   {/* dark navy */}
        <stop offset="20%" stopColor="#156FAF" />  {/* brand blue */}
        <stop offset="55%" stopColor="#1FC8A5" />  {/* teal */}
        <stop offset="100%" stopColor="#56D364" /> {/* green */}
      </linearGradient>
    </defs>

    <path
      fill="url(#bottomGrad)"
      d="
        M700,700
        L0,700
        C100,600 200,450 350,400
        C550,330 700,250 700,0
        Z
      "
    />
  </svg>
</div>

      {/* MAIN CONTAINER */}
      <div className="relative z-10 w-[92%] max-w-5xl bg-white rounded-[30px] shadow-[0_20px_70px_-15px_rgba(0,0,0,0.12)] flex overflow-hidden min-h-[600px]">
        
        {/* LEFT SIDE: ILLUSTRATION AREA */}
        <div className="hidden lg:flex w-1/2 relative items-center justify-center p-12">
          {/* Internal gradient behind the illustration */}
          <div className="absolute inset-0 opacity-70" />
          
          <motion.img
            src={illustration}
            alt="Secure Login"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            className="relative z-10 w-full max-w-[700px]"
          />
        </div>

        {/* RIGHT SIDE: FORM CONTENT */}
        <div className="w-full lg:w-1/2 flex items-center justify-center bg-white px-5">
          <div className="w-full max-w-lg">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}


// import { motion } from "framer-motion";
// import { DOMAIN_ILLUSTRATION_MAP } from "../../utils/domainIllustrationMap";

// export default function AuthLayout({ children, showIllustration = true }) {
//   const domain = window.location.hostname.replace(/^www\./, "");

//   const illustration =
//     DOMAIN_ILLUSTRATION_MAP[domain] ||
//     "/images/login-default.webp";

//   return (
//     <div className="
//       min-h-screen w-full relative overflow-hidden
//       bg-gradient-to-br from-[#F8FAFF] via-[#EAF1FF] to-[#D6E4FF]
//       flex items-center justify-center
//     ">
//       {/* BACKGROUND BLOBS */}
//       <div className="absolute -top-40 -left-40 w-[420px] h-[420px] bg-[#A9C8FF] rounded-full blur-[140px] opacity-50" />
//       <div className="absolute top-1/4 -right-48 w-[520px] h-[520px] bg-[#0A5BFF] rounded-full blur-[180px] opacity-30" />
//       <div className="absolute bottom-0 left-1/4 w-[420px] h-[420px] bg-[#0B2E6F] rounded-full blur-[180px] opacity-25" />

//       <div className="relative z-10 w-full max-w-6xl flex bg-slate-50 p-6 rounded-2xl shadow-xl min-h-[600px]">
//         {/* LEFT ILLUSTRATION */}
//         {showIllustration && (
//           <div className="hidden lg:flex w-1/2 items-center justify-center">
//             <motion.img
//               src={`${process.env.PUBLIC_URL}${illustration}`}
//               alt="Login Illustration"
//               initial={{ opacity: 0, x: -40 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//               className="max-w-[420px] w-full"
//             />
//           </div>
//         )}

//         {/* RIGHT CONTENT */}
//         <div className="w-full lg:w-1/2 flex items-center justify-center px-6">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// }


// // src/components/auth/AuthLayout.jsx
// import { motion } from "framer-motion";

// export default function AuthLayout({
//   children,
//   showIllustration = true,
// }) {
//   return (
//     <div className="
//       min-h-screen w-full relative overflow-hidden
//       bg-gradient-to-br from-[#F8FAFF] via-[#EAF1FF] to-[#D6E4FF]
//       flex items-center justify-center
//     ">

//       {/* BLURRED BACKGROUND SHAPES */}
//       <div className="absolute -top-40 -left-40 w-[420px] h-[420px] bg-[#A9C8FF] rounded-full blur-[140px] opacity-50" />
//       <div className="absolute top-1/4 -right-48 w-[520px] h-[520px] bg-[#0A5BFF] rounded-full blur-[180px] opacity-30 " />
//       <div className="absolute bottom-0 left-1/4 w-[420px] h-[420px] bg-[#0B2E6F] rounded-full blur-[180px] opacity-25" />


//       {/* CENTERED CARD CONTAINER */}
//       <div className="
//         relative z-10
//         w-full max-w-6xl
//         flex
//         bg-slate-50
//         p-6
//         rounded-2xl
//         shadow-xl
//         min-h-[600px]
//       ">


//         {/* LEFT ILLUSTRATION */}
//         {showIllustration && (
//           <div className="hidden lg:flex w-1/2 items-center justify-center">
//             <motion.img
//               src={require("../../asset/images/login.webp")}
//               alt="Login Illustration"
//               initial={{ opacity: 0, x: -40 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//               className="max-w-[420px] w-full"
//             />
//           </div>
//         )}

//         {/* RIGHT CONTENT */}
//         <div className="w-full lg:w-1/2 flex items-center justify-center px-6">
//           {children}
//         </div>

//       </div>
//     </div>
//   );
// }



// // components/auth/AuthLayout.jsx
// import { motion } from "framer-motion";

// export default function AuthLayout({ children, showIllustration = true }) {
//   return (
//     <div className="min-h-screen relative flex overflow-hidden bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100">

//       {/* Decorative blobs */}
//       <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-400 rounded-full blur-3xl opacity-30" />
//       <div className="absolute top-1/3 -right-24 w-96 h-96 bg-indigo-400 rounded-full blur-3xl opacity-30" />
//       <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-purple-400 rounded-full blur-3xl opacity-30" />

//       {/* Illustration */}
//       {showIllustration && (
//         <div className="hidden lg:flex w-1/2 items-center justify-center p-10">
//           <motion.img
//             src={require("../../asset/images/login.webp")}
//             alt="Auth Illustration"
//             initial={{ opacity: 0, x: -40 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.5 }}
//             className="max-w-md w-full max-h-96"
//           />
//         </div>
//       )}

//       {/* Content */}
//       <div className="w-full lg:w-1/2 flex items-center justify-center px-4">
//         {children}
//       </div>
//     </div>
//   );
// }
